import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './SkeletonCard.scss';
import { isMobile } from 'react-device-detect';

const SkeletonCard = ({ variant = 'song', width = null, height = null }) => {
  // Dark theme colors for skeleton
  const skeletonBaseColor = '#2a2a2a';
  const skeletonHighlightColor = '#3a3a3a';

  if (variant === 'genre') {
    return (
      <div className="skeleton-card genre">
        <Skeleton
          height={152}
          width={146}
          borderRadius={6}
          baseColor={skeletonBaseColor}
          highlightColor={skeletonHighlightColor}
        />
      </div>
    );
  }

  // Song variant
  return (
    <div className="skeleton-card song">
      <Skeleton
        height={height ?? (isMobile ? 64 : 100)}
        width={width ?? (isMobile ? 308 : 403)}
        borderRadius={12}
        baseColor={skeletonBaseColor}
        highlightColor={skeletonHighlightColor}
      />
    </div>
  );
};

export default SkeletonCard;
